import React from "react";
import { Routes, Route } from "react-router-dom";
import ListVrShootRequest from "../Components/VR Shoot Request/listVrShootRequest";
// import ViewVrShootRequest from "../Components/VR Shoot Request/viewVrShootRequest";

const VrShootRequestRoutes = () => {
  return (
    <Routes>
      <Route
        path="/vr_shoot_request"
        element={<ListVrShootRequest />}
      />
      {/* <Route
        path="/vr-shoot-request/view/:id"
        element={<ViewVrShootRequest />}
      /> */}
    </Routes>
  );
};

export default VrShootRequestRoutes;